export default __webpack_public_path__ + "static/media/site_link.9785c930.png";